import React from "react";

import { EmptySearch, ErrorState } from "@tiendanube/components";
import { useTranslation } from "react-i18next";

import ProductRow from "../ProductRow";
import VirtualDataList from "../../../../commons/VirtualDataList";
import ProductResultsSkeleton from "../ProductResultsSkeleton";
import { ProductResponseDto } from "../../dtos";

interface ProductResultsProps {
    prods: ProductResponseDto[];
    showEmptySearch: boolean;
    showSkeletons: boolean;
    showError: boolean;
    showFooter: boolean;
    refetch: () => void;
    loadMoreProducts: () => void;
}

function ProductResults({ prods,
    showEmptySearch,
    showSkeletons,
    showError,
    showFooter,
    refetch,
    loadMoreProducts }: ProductResultsProps): JSX.Element {

    const { t } = useTranslation();

    const data = prods.map(() => "void");

    if (showSkeletons) {
        return <ProductResultsSkeleton />;
    }

    if (showEmptySearch) {
        return (
            <EmptySearch
                text={t('productNoResults.text')}
                title={t('productNoResults.title')}
            />
        );
    }

    if (showError) {
        return (
            <ErrorState
                title={t('productErrorResults.title')}
                action={{
                    children: t('productErrorResults.action'),
                    onClick: refetch,
                }}
            />
        );
    }

    return (
        <VirtualDataList
            data={data}
            endReached={loadMoreProducts}
            itemContent={(index) => <ProductRow product={prods[index]} />}
            showFooter={showFooter}
        />
    )
}

export default ProductResults;